export default {
    title: 'XMED Therapy Demo',
    defaultLocale: 'hu',
    fallbackLocale: 'en',
    retroactiveWindowHours: 48,
    demoAccounts: [
        {role: 'patient', email: 'patient@demo.xmed.hu', password: 'password', label: 'Demo Páciens'},
        {role: 'patient', email: 'patient2@demo.xmed.hu', password: 'password', label: 'Kovács Anna'},
        {role: 'patient', email: 'patient3@demo.xmed.hu', password: 'password', label: 'Nagy Béla'},
        {role: 'patient', email: 'patient4@demo.xmed.hu', password: 'password', label: 'Szabó Csilla'},
        {role: 'doctor', email: 'doctor@demo.xmed.hu', password: 'password', label: 'Dr. Demo Orvos'},
        {role: 'doctor', email: 'doctor2@demo.xmed.hu', password: 'password', label: 'Dr. Kiss Éva'},
        {role: 'doctor', email: 'doctor3@demo.xmed.hu', password: 'password', label: 'Dr. Tóth Gábor'},
        {role: 'doctor', email: 'doctor4@demo.xmed.hu', password: 'password', label: 'Dr. Horváth Ildikó'},
        {role: 'admin', email: 'admin@demo.xmed.hu', password: 'password', label: 'Demo Admin'},
    ],
};
